export default "__VITE_ASSET__CVr80rIq__"